var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F59B00",
    fillRule: "evenodd",
    d: "M21.8 2.2a.682.682 0 0 1 0 .964L12.964 12l8.836 8.836a.681.681 0 1 1-.964.964L12 12.964 3.164 21.8a.68.68 0 0 1-.964 0 .682.682 0 0 1 0-.964L11.035 12 2.2 3.164a.682.682 0 0 1 .964-.964L12 11.036 20.836 2.2a.682.682 0 0 1 .964 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.0e044c27d915242001a5cc2af426645a.svg";
export { ForwardRef as ReactComponent };